'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dStorage$002dFormat$0024$0024anon$00241 from "./app.data.-App-Document-Storage-Format$$anon$1.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $s_Lapp_data_AppDocumentStorageFormat$__GzippedJson__Lapp_data_AppDocumentStorageFormat() {
  $m_Lapp_data_AppDocumentStorageFormat$();
  return $t_Lapp_data_AppDocumentStorageFormat$__GzippedJson;
}
export { $s_Lapp_data_AppDocumentStorageFormat$__GzippedJson__Lapp_data_AppDocumentStorageFormat as $s_Lapp_data_AppDocumentStorageFormat$__GzippedJson__Lapp_data_AppDocumentStorageFormat };
/** @constructor */
function $c_Lapp_data_AppDocumentStorageFormat$() {
  this.azJ = null;
  this.azK = false;
  this.azL = null;
  this.azM = false;
  $n_Lapp_data_AppDocumentStorageFormat$ = this;
  $t_Lapp_data_AppDocumentStorageFormat$__GzippedJson = new $j_app$002edata$002e$002dApp$002dDocument$002dStorage$002dFormat$0024$0024anon$00241.$c_Lapp_data_AppDocumentStorageFormat$$anon$1("GzippedJson", 0);
  $s_Lapp_data_AppDocumentStorageFormat$__GzippedJson__Lapp_data_AppDocumentStorageFormat();
}
export { $c_Lapp_data_AppDocumentStorageFormat$ as $c_Lapp_data_AppDocumentStorageFormat$ };
$p = $c_Lapp_data_AppDocumentStorageFormat$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentStorageFormat$;
/** @constructor */
function $h_Lapp_data_AppDocumentStorageFormat$() {
}
export { $h_Lapp_data_AppDocumentStorageFormat$ as $h_Lapp_data_AppDocumentStorageFormat$ };
$h_Lapp_data_AppDocumentStorageFormat$.prototype = $p;
$p.bp2 = (function() {
  if ((!this.azK)) {
    this.azJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_CirceKeyCodec$$anon$2(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => ((x$1 === "gj") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($s_Lapp_data_AppDocumentStorageFormat$__GzippedJson__Lapp_data_AppDocumentStorageFormat()) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1$2) => {
      var x = $s_Lapp_data_AppDocumentStorageFormat$__GzippedJson__Lapp_data_AppDocumentStorageFormat();
      if (((x === null) ? (x$1$2 === null) : (x === x$1$2))) {
        return "gj";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1$2);
    })));
    this.azK = true;
  }
  return this.azJ;
});
$p.bNr = (function() {
  if ((!this.azM)) {
    this.azL = new $c_Lapp_data_AppDocumentStorageFormat$$anon$2();
    this.azM = true;
  }
  return this.azL;
});
$p.dl = (function(x) {
  return x.ahx;
});
var $d_Lapp_data_AppDocumentStorageFormat$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentStorageFormat$, "app.data.AppDocumentStorageFormat$", ({
  Ct: 1,
  d: 1,
  D: 1
}));
export { $d_Lapp_data_AppDocumentStorageFormat$ as $d_Lapp_data_AppDocumentStorageFormat$ };
var $n_Lapp_data_AppDocumentStorageFormat$;
function $m_Lapp_data_AppDocumentStorageFormat$() {
  if ((!$n_Lapp_data_AppDocumentStorageFormat$)) {
    $n_Lapp_data_AppDocumentStorageFormat$ = new $c_Lapp_data_AppDocumentStorageFormat$();
  }
  return $n_Lapp_data_AppDocumentStorageFormat$;
}
export { $m_Lapp_data_AppDocumentStorageFormat$ as $m_Lapp_data_AppDocumentStorageFormat$ };
/** @constructor */
function $c_Lapp_data_AppDocumentStorageFormat$$anon$2() {
}
export { $c_Lapp_data_AppDocumentStorageFormat$$anon$2 as $c_Lapp_data_AppDocumentStorageFormat$$anon$2 };
$p = $c_Lapp_data_AppDocumentStorageFormat$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentStorageFormat$$anon$2;
/** @constructor */
function $h_Lapp_data_AppDocumentStorageFormat$$anon$2() {
}
export { $h_Lapp_data_AppDocumentStorageFormat$$anon$2 as $h_Lapp_data_AppDocumentStorageFormat$$anon$2 };
$h_Lapp_data_AppDocumentStorageFormat$$anon$2.prototype = $p;
$p.aT = (function(t) {
  return $m_Lapp_data_AppDocumentStorageFormat$().bp2().vK(t);
});
var $d_Lapp_data_AppDocumentStorageFormat$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentStorageFormat$$anon$2, "app.data.AppDocumentStorageFormat$$anon$2", ({
  Cv: 1,
  a: 1,
  aO: 1,
  aN: 1
}));
export { $d_Lapp_data_AppDocumentStorageFormat$$anon$2 as $d_Lapp_data_AppDocumentStorageFormat$$anon$2 };
var $t_Lapp_data_AppDocumentStorageFormat$__GzippedJson = null;
function $u_Lapp_data_AppDocumentStorageFormat$__GzippedJson(x) {
  $t_Lapp_data_AppDocumentStorageFormat$__GzippedJson = x;
}
export { $t_Lapp_data_AppDocumentStorageFormat$__GzippedJson as $t_Lapp_data_AppDocumentStorageFormat$__GzippedJson, $u_Lapp_data_AppDocumentStorageFormat$__GzippedJson as $u_Lapp_data_AppDocumentStorageFormat$__GzippedJson };
//# sourceMappingURL=app.data.-App-Document-Storage-Format$.js.map
